import { Invite, Invites } from 'types/organization/invites';
import { Students } from 'types/organization/students';
import { Student } from 'types/organization/students';

export const filterUsersByClass = (usersList: Invites | Students, classId: string, includeInClass: boolean = true) => {
  if (Array.isArray(usersList) && usersList.length > 0) {
    if ('organisationName' in usersList[0]) {
      return (usersList as Invites).filter((invite) =>
        includeInClass
          ? invite.classes?.some((classItem) => classItem.id === classId)
          : !invite.classes?.some((classItem) => classItem.id === classId)
      );
    } else if ('performanceUrl' in usersList[0]) {
      return (usersList as Students).filter((student) =>
        includeInClass
          ? student.classes?.some((classItem) => classItem.id === classId)
          : !student.classes?.some((classItem) => classItem.id === classId)
      );
    }
  }
  return [];
};

export const filterOrganizationStudentsByClass = (studentList: Student[], selectedClassId: string) => {
  return studentList?.filter((student) => student.classes?.map((c) => c.id).includes(selectedClassId)) ?? [];
};

export const filterOrganizationInvitesByClass = (invitesList: Invite[], selectedClassId: string) => {
  return invitesList?.filter((invite) => invite.classes.map((c) => c.id).includes(selectedClassId));
};
